export class Csrf {
	private static _token: string | undefined;
	static headers(): Dictionary<string> {
		const token = this.token();
		if (token) {
			return {
				'X-CSRF-Token': token,
			};
		} else {
			return {};
		}
	}
	static token() {
		return (this._token = this._token || this._find_token());
	}
	private static _find_token() {
		const meta_token_element = document.querySelector('meta[name="csrf-token"]');
		if (meta_token_element) {
			return meta_token_element.getAttribute('content') || undefined;
		}
		// if(meta_token_element){
		// 	axios.defaults.headers.common['X-CSRF-Token'] =
		// }
	}
}
